import React from 'react';
import { Box, Container, Typography, Paper, Rating, Avatar, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

// Styled components
const TestimonialPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
  },
}));

const QuoteIcon = styled(FormatQuoteIcon)(({ theme }) => ({
  fontSize: 40,
  color: theme.palette.primary.main,
  opacity: 0.2,
  marginBottom: theme.spacing(2),
}));

interface Testimonial {
  id: number;
  name: string;
  location: string;
  image: string | null;
  rating: number;
  text: string;
}

// Real customer reviews only, used with the customer's permission. The old
// placeholder reviews were removed so they can't be switched on by accident.
const testimonials: Testimonial[] = [];

const TestimonialsSection: React.FC = () => {
  // Component temporarily hidden
  return null;
};

export default TestimonialsSection;
